import { useState } from "react";
import QuestionnairePage from "./QuestionnairePage";
import "./QuestionnaireModal.scss";
import MainHeader from "../PublicComponents/MainHeader";

type QuestionnaireModalProps = {
  isOpen: boolean;
  onClose: () => void;
  orderData: any;
  token: string | null;
  modalIndex?: number;
};

export default function QuestionnaireModal({
  isOpen,
  onClose,
  orderData,
  token,
  modalIndex = 0,
}: QuestionnaireModalProps) {
  const [isMinimized, setIsMinimized] = useState(false);
  const [isFullScreen, setIsFullScreen] = useState(false);

  if (!isOpen) return null;

  const baseZIndex = 999 + modalIndex;

  return (
    <>
      {/* Full Screen Modal */}
      {isFullScreen && (
        <div className="modal-full-screen" style={{ zIndex: baseZIndex + 100 }}>
          <div className="modal-header-bar">
            <h2>Questionnaire - {orderData?.order_number}|| Country - {orderData?.country_name}</h2>
            <div className="modal-controls">
              <button 
                onClick={() => setIsFullScreen(false)} 
                className="control-btn restore-btn"
                title="Restore"
              >
                ▢
              </button>
              <button 
                onClick={onClose} 
                className="control-btn close-btn"
                title="Close"
              >
                ✕
              </button>
            </div>
          </div>
          <div className="modal-body">
            <MainHeader />
            <QuestionnairePage initialData={orderData} token={token} />
          </div>
        </div>
      )}

      {/* Minimized Modal (Bottom Right Corner) */}
      {isMinimized && !isFullScreen && (
        <div className="modal-minimized" style={{ zIndex: baseZIndex + 50, bottom: `${20 + modalIndex * 260}px` }}>
          <div className="modal-minimized-header">
            <span className="minimized-title">Questionnaire - {orderData?.order_number} || Country -{orderData?.country_name}</span>
            <div className="minimized-controls">
              <button 
                onClick={() => setIsMinimized(false)} 
                className="control-btn restore-btn"
                title="Restore"
              >
                ⬜
              </button>
              <button 
                onClick={onClose} 
                className="control-btn close-btn"
                title="Close"
              >
                ✕
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Normal Modal (Windowed View) */}
      {!isMinimized && !isFullScreen && (
        <div className="modal-overlay" style={{ zIndex: baseZIndex }}>
          <div className="modal-window" onClick={(e) => e.stopPropagation()} style={{ marginTop: `${modalIndex * 30}px`, marginLeft: `${modalIndex * 30}px` }}>
            <div className="modal-header-bar">
              <h2>Questionnaire - {orderData?.order_number} || Country - {orderData?.country_name}</h2>
              <div className="modal-controls">
                <button 
                  onClick={() => setIsFullScreen(true)} 
                  className="control-btn fullscreen-btn"
                  title="Fullscreen"
                >
                  ⛶
                </button>
                <button 
                  onClick={() => setIsMinimized(true)} 
                  className="control-btn minimize-btn"
                  title="Minimize"
                >
                  −
                </button>
                <button 
                  onClick={onClose} 
                  className="control-btn close-btn"
                  title="Close"
                >
                  ✕
                </button>
              </div>
            </div>
            <div className="modal-body">
                <MainHeader />
              <QuestionnairePage initialData={orderData} token={token} />
            </div>
          </div>
        </div>
      )}
    </>
  );
}